/**
 * @Description : 微应用title配置
 */
export var microRoutes = [
    {
        path: '/lhb-micro-pms/billboards',
        name: 'MicroResourceBillboards',
        meta: { title: '经营看板' },
    },
    {
        path: '/lhb-micro-pms/billboards/detail',
        name: 'MicroResourceBillboardsDetail',
        meta: {
            title: '客流详情',
            isShowNav: true,
            activeMenu: '/lhb-micro-pms/billboards',
            crumbs: {
                path: ['/lhb-micro-pms/billboards'],
                name: ['经营看板'],
            },
        }
    },
    {
        path: '/lhb-micro-pms/brandBusiness',
        name: 'MicroResourceBrandBusiness',
        meta: {
            title: '品牌商机',
        },
    },
    {
        path: '/lhb-micro-pms/brandBusiness/analysis',
        name: 'MicroResourceBrandBusinessAnalysis',
        meta: {
            title: '商机趋势',
            isShowNav: true,
            activeMenu: '/lhb-micro-pms/brandBusiness',
            crumbs: {
                path: ['/lhb-micro-pms/brandBusiness'],
                name: ['品牌商机'],
            },
        },
    },
    {
        path: '/lhb-micro-pms/investmentMaterial',
        name: 'MicroResourceInvestmentMaterial',
        meta: { title: '招商管理' },
    },
    {
        path: '/lhb-micro-pms/placeMng',
        name: 'MicroResourcePlaceMng',
        meta: { title: '项目管理' },
    },
    {
        path: '/lhb-micro-pms/placeMng/detail',
        name: 'MicroResourcePlaceMng',
        meta: {
            title: '项目详情',
            isShowNav: true,
            activeMenu: '/lhb-micro-pms/placeMng',
            crumbs: {
                path: ['/lhb-micro-pms/placeMng'],
                name: ['项目管理'],
            },
        },
    },
    {
        path: '/lhb-micro-pms/placeMng/edit',
        name: 'MicroResourcePlaceMngEdit',
        meta: {
            title: '项目编辑',
            isShowNav: true,
            activeMenu: '/lhb-micro-pms/placeMng',
            crumbs: {
                path: ['/lhb-micro-pms/placeMng'],
                name: ['项目管理'],
            },
        },
    },
    {
        path: '/lhb-micro-pms/pointMng',
        name: 'MicroResourcePointMng',
        meta: { title: '展位管理' },
    },
    {
        path: '/lhb-micro-pms/pointMng/detail',
        name: 'MicroResourcePointMngDetail',
        meta: {
            title: '展位详情',
            isShowNav: true,
            activeMenu: '/lhb-micro-pms/pointMng',
            crumbs: {
                path: ['/lhb-micro-pms/pointMng'],
                name: ['展位管理'],
            },
        },
    },
    {
        path: '/lhb-micro-pms/pointMng/edit',
        name: 'MicroResourcePointMngEdit',
        meta: {
            title: '展位编辑',
            isShowNav: true,
            activeMenu: '/lhb-micro-pms/pointMng',
            crumbs: {
                path: ['/lhb-micro-pms/pointMng'],
                name: ['展位管理'],
            },
        },
    },
    {
        path: '/lhb-micro-pms/adsMng',
        name: 'MicroResourceAdsMng',
        meta: { title: '广告位管理' },
    },
    {
        path: '/lhb-micro-pms/adsMng/detail',
        name: 'MicroResourcePointMngDetail',
        meta: {
            title: '广告位详情',
            isShowNav: true,
            activeMenu: '/lhb-micro-pms/adsMng',
            crumbs: {
                path: ['/lhb-micro-pms/adsMng'],
                name: ['广告位管理'],
            },
        },
    },
    {
        path: '/lhb-micro-pms/adsMng/edit',
        name: 'MicroResourcePointMngEdit',
        meta: {
            title: '广告位编辑',
            isShowNav: true,
            activeMenu: '/lhb-micro-pms/adsMng',
            crumbs: {
                path: ['/lhb-micro-pms/adsMng'],
                name: ['广告位管理'],
            },
        },
    },
    {
        path: '/lhb-micro-pms/caseMng',
        name: 'MicroResourceCaseMng',
        meta: { title: '案例管理' },
    },
    {
        path: '/lhb-micro-pms/caseMng/detail',
        name: 'MicroResourceCaseMng',
        meta: {
            title: '案例详情',
            isShowNav: true,
            activeMenu: '/lhb-micro-pms/caseMng',
            crumbs: {
                path: ['/lhb-micro-pms/caseMng'],
                name: ['案例管理'],
            },
        },
    },
    {
        path: '/lhb-micro-pms/priceMng',
        name: 'MicroResourcePriceMng',
        meta: { title: '价格管理' },
    },
    {
        path: '/lhb-micro-pms/labelSet',
        name: 'MicroLabelSet',
        meta: { title: '标签设置' },
    },
    {
        path: '/lhb-micro-pms/roleSet',
        name: 'MicroRoleSet',
        meta: { title: '角色设置' },
    },
    {
        path: '/lhb-micro-pms/organization/department',
        name: 'MicroResourceDepartment',
        meta: { title: '部门管理' },
    },
    {
        path: '/lhb-micro-pms/organization/post',
        name: 'MicroResourcePost',
        meta: { title: '岗位管理' },
    },
    {
        path: '/lhb-micro-pms/organization/user',
        name: 'MicroResourceUser',
        meta: { title: '用户管理' },
    },
    {
        path: '/lhb-micro-pms/organization/role',
        name: 'MicroResourceRole',
        meta: { title: '角色管理' },
    },
    {
        path: '/lhb-micro-pms/organization/permission',
        name: 'MicroResourcePermission',
        meta: { title: '权限管理' },
    },
    {
        path: '/lhb-micro-pms/sales',
        name: 'MicroResourceSales',
        meta: { title: '销售单管理' },
    },
    {
        path: '/lhb-micro-pms/sales/detail',
        name: 'MicroResourceSalesDetail',
        meta: { title: '销售单详情' },
    },
    {
        path: '/lhb-micro-pms/purchase',
        name: 'MicroResourcePurchase',
        meta: { title: '采购单管理' },
    },
    {
        path: '/lhb-micro-pms/purchase/detail',
        name: 'MicroResourcePurchaseDetail',
        meta: { title: '采购单详情' },
    },
    {
        path: '/lhb-micro-pms/purchaseTask',
        name: 'MicroResourcePurchaseTask',
        meta: { title: '采购任务管理' },
    },
    {
        path: '/lhb-micro-pms/purchaseTask/detail',
        name: 'MicroResourcePurchaseTaskDetail',
        meta: { title: '采购任务详情' },
    },
    {
        path: '/lhb-micro-pms/assetsManage',
        name: 'MicroResourceAssetsManage',
        meta: { title: '资产经营' },
    },
    {
        path: '/lhb-micro-pms/markupAnalysis',
        name: 'MicroResourceMarkupAnalysis',
        meta: { title: '加价率分析' },
    },
    {
        path: '/lhb-micro-pms/useRateAnalysis',
        name: 'MicroResourceUseRateAnalysis',
        meta: { title: '利用率分析' },
    },
    {
        path: '/lhb-micro-pms/orderRole',
        name: 'MicroResourceOrderRole',
        meta: { title: '订单角色管理' },
    },
    {
        path: '/lhb-micro-pms/bunksMng',
        name: 'MicroResourceBunksMng',
        meta: { title: '商铺管理' },
    },
    {
        path: '/lhb-micro-pms/bunksMng/detail',
        name: 'MicroResourceBunksMngDetail',
        meta: {
            title: '商铺详情',
            isShowNav: true,
            activeMenu: '/lhb-micro-pms/bunksMng',
            crumbs: {
                path: ['/lhb-micro-pms/bunksMng'],
                name: ['商铺管理'],
            },
        },
    },
    {
        path: '/lhb-micro-pms/bunksMng/edit',
        name: 'MicroResourceBunksMngEdit',
        meta: {
            title: '商铺编辑',
            isShowNav: true,
            activeMenu: '/lhb-micro-pms/bunksMng',
            crumbs: {
                path: ['/lhb-micro-pms/bunksMng'],
                name: ['商铺管理'],
            },
        },
    },
    {
        path: '/lhb-micro-pms/supplierMng',
        name: 'MicroResourceSupplierMng',
        meta: { title: '供应商管理' },
    },
    {
        path: '/lhb-micro-pms/replayMng',
        name: 'MicroResourceReplayMng',
        meta: { title: '资产复盘' },
    },
    {
        path: '/lhb-micro-pms/reviewSet',
        name: 'MicroResourceReviewSet',
        meta: { title: '复盘设置' },
    },
    {
        path: '/lhb-micro-pms/takeOffAudit',
        name: 'MicroResourceTakeOffAudit',
        meta: { title: '上下架审核' },
    },
    {
        path: '/lhb-micro-pms/takeOffAudit/edit',
        name: 'MicroResourceTakeOffAuditEdit',
        meta: {
            title: '上下架审核-编辑审核详情',
            isShowNav: true,
            activeMenu: '/lhb-micro-pms/takeOffAudit',
            crumbs: {
                path: ['/lhb-micro-pms/takeOffAudit'],
                name: ['上下架审核'],
            },
        },
    },
    {
        path: '/lhb-micro-pms/takeOffAudit/detail',
        name: 'MicroResourceTakeOffAuditDetail',
        meta: {
            title: '上下架审核详情',
            isShowNav: true,
            activeMenu: '/lhb-micro-pms/takeOffAudit',
            crumbs: {
                path: ['/lhb-micro-pms/takeOffAudit'],
                name: ['上下架审核'],
            },
        },
    },
    {
        path: '/lhb-micro-pms/labelAudit',
        name: 'MicroResourceLabelAudit',
        meta: { title: '标签审核' },
    },
    {
        path: '/lhb-micro-pms/labelAudit/detail',
        name: 'MicroResourceLabelAuditDetail',
        meta: {
            title: '标签审核详情',
            isShowNav: true,
            activeMenu: '/lhb-micro-pms/labelAudit',
            crumbs: {
                path: ['/lhb-micro-pms/labelAudit'],
                name: ['标签审核'],
            },
        },
    },
    {
        path: '/lhb-micro-pms/reviewApprove',
        name: 'MicroResourceReviewApprove',
        meta: { title: '复盘审核' },
    },
    {
        path: '/lhb-micro-pms/paymentRecord',
        name: 'MicroResourcePaymentRecord',
        meta: { title: '付款记录' },
    },
    {
        path: '/lhb-micro-pms/paymentRecord/detail',
        name: 'MicroResourcePaymentRecordDetail',
        meta: {
            title: '付款详情',
            isShowNav: true,
            activeMenu: '/lhb-micro-pms/paymentRecord',
            crumbs: {
                path: ['/lhb-micro-pms/paymentRecord'],
                name: ['付款记录'],
            },
        },
    },
    {
        path: '/lhb-micro-pms/business',
        name: 'MicroResourceBusiness',
        meta: { title: '商机', isShowHeader: false, isNotShowNav: true },
    },
    {
        path: '/lhb-micro-pms/ppt',
        name: 'MicroResourcePPT',
        meta: { title: 'ppt', isShowHeader: false, isNotShowNav: true },
    },
];
